<template>
  <div class="about">
    <h1>Catalog</h1>
  </div>
</template>

<script>
export default {
  name: 'Catalog',
  data () {}
}
</script>
